export default __webpack_public_path__ + "static/media/soborno.ebaceee1.png";